import { render, staticRenderFns } from "./MessageStatus.vue?vue&type=template&id=bd9ddeb0&scoped=true&"
import script from "./MessageStatus.vue?vue&type=script&lang=js&"
export * from "./MessageStatus.vue?vue&type=script&lang=js&"
import style0 from "./MessageStatus.vue?vue&type=style&index=0&id=bd9ddeb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9ddeb0",
  null
  
)

export default component.exports